/**
 * This plugin injects global safe versions of localStorage and sessionStorage
 * to prevent errors during SSR.
 */
export default defineNuxtPlugin(() => {
  // Create a safe wrapper for localStorage
  const safeLocalStorage = {
    getItem(key: string): string | null {
      if (process.client && window.localStorage) {
        try {
          return window.localStorage.getItem(key)
        } catch (error) {
          console.error('Error accessing localStorage.getItem', error)
          return null
        }
      }
      return null
    },
    
    setItem(key: string, value: string): void {
      if (process.client && window.localStorage) {
        try {
          window.localStorage.setItem(key, value)
        } catch (error) {
          console.error('Error accessing localStorage.setItem', error)
        }
      }
    },
    
    removeItem(key: string): void {
      if (process.client && window.localStorage) {
        try {
          window.localStorage.removeItem(key)
        } catch (error) {
          console.error('Error accessing localStorage.removeItem', error)
        }
      }
    },
    
    clear(): void {
      if (process.client && window.localStorage) {
        try {
          window.localStorage.clear()
        } catch (error) {
          console.error('Error accessing localStorage.clear', error)
        }
      }
    }
  }
  
  // Create a safe wrapper for sessionStorage
  const safeSessionStorage = {
    getItem(key: string): string | null {
      if (process.client && window.sessionStorage) {
        try {
          return window.sessionStorage.getItem(key)
        } catch (error) {
          console.error('Error accessing sessionStorage.getItem', error)
          return null
        }
      }
      return null
    },
    
    setItem(key: string, value: string): void {
      if (process.client && window.sessionStorage) {
        try {
          window.sessionStorage.setItem(key, value)
        } catch (error) {
          console.error('Error accessing sessionStorage.setItem', error)
        }
      }
    },
    
    removeItem(key: string): void {
      if (process.client && window.sessionStorage) {
        try {
          window.sessionStorage.removeItem(key)
        } catch (error) {
          console.error('Error accessing sessionStorage.removeItem', error)
        }
      }
    },
    
    clear(): void {
      if (process.client && window.sessionStorage) {
        try {
          window.sessionStorage.clear()
        } catch (error) {
          console.error('Error accessing sessionStorage.clear', error)
        }
      }
    }
  }
  
  // Provide the safe storage helpers
  return {
    provide: {
      localStorage: safeLocalStorage,
      sessionStorage: safeSessionStorage
    }
  }
}) 